import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import puc from '../img/page_under_construction.png';

const UnderConstruction = () => {
  const { strings } = useLanguage();
  return (
    <div style={{ display: 'inline-block', alignContent: 'center', textAlign: 'center' }}>
      <img
        src={puc}
        alt={strings.page_under_constuction}
        width="60"
        height="60"
        style={{ objectFit: 'contain' }}
        />
        <p>{strings.page_under_constuction}</p> 
        <p>{strings.page_under_constuction_coming_soon}</p>
    </div>)
};
export default UnderConstruction;
